export default function ($translate) {
    return {
        KEYS: {
            COMPULSORY: 'COMPULSORY',
            OPTIONAL: 'OPTIONAL'
        },
        LABELS: {
            COMPULSORY: $translate.instant('course.target.Compulsory'),
            OPTIONAL: $translate.instant('course.target.optional')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/target/needType/index.js